import { render, staticRenderFns } from "./DadosTerceiroForm.vue?vue&type=template&id=d0055e7a&scoped=true"
import script from "./DadosTerceiroForm.vue?vue&type=script&lang=js"
export * from "./DadosTerceiroForm.vue?vue&type=script&lang=js"
import style0 from "./DadosTerceiroForm.vue?vue&type=style&index=0&id=d0055e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0055e7a",
  null
  
)

export default component.exports